<template>
	<section class="main-content intro">
		<div class="row">
			<slot>
				<div class="columns column12 align-center">
					<h1>{{ title }}</h1>
					<slot name="extra-heading" />
					<div v-parse-links v-html="content" />
					<slot name="extra-content" />
				</div>
			</slot>
		</div>
	</section>
</template>

<script setup>
defineProps({
	title: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.intro {
	.row {
		max-width: 800px;
		background: #fff;
		padding: 30px;
		z-index: 2;
		position: relative;
	}
}

@media (max-width: 880px) {
	.intro {
		.row {
			width: 82%;
			padding: 25px 5px;
		}
	}
}
</style>
